export const LOAD_API = 'LOAD_API';
export const LOAD_API_ERR = 'LOAD_API_ERR';
export const SET_LOADING = 'SET_LOADING';
export const SET_CURRENT_CURRENCY = 'SET_CURRENT_CURRENCY';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const CHANGE_UNIT_STATE = 'CHANGE_UNIT_STATE';
export const SAVE_UNITS = 'SAVE_UNITS';
export const SEARCH_UNITS = 'SEARCH_UNITS';
export const GET_RATES = 'GET_RATES';
export const CHANGE_CURRENT_RATE = 'CHANGE_CURRENT_RATE';
export const ADD_CURRENCY = 'ADD_CURRENCY';
export const GET_CRYPTOES = 'GET_CRYPTOES';
export const FILTER_CRYPTOES = 'FILTER_CRYPTOES';
export const CHANGE_UNIT_BTN = 'CHANGE_UNIT_BTN';
export const ADD_CURRENCY_BTN = 'ADD_CURRENCY_BTN';
export const SET_SHOW_MENU = 'SET_SHOW_MENU';
